import { render, staticRenderFns } from "./OrganizationSettings.vue?vue&type=template&id=773f0b13&scoped=true&"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js&"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSettings.css?vue&type=style&index=0&id=773f0b13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773f0b13",
  null
  
)

export default component.exports